<template>

  <div class="pros" v-if="list && list.length">

    <h2 class="divider-sec">
      {{ title }} 
      <nuxt-link class="h2_show_all" :to="link">
        {{ showmore }} 
      </nuxt-link>
    </h2>

    <div class="questionlist" v-if="list">    
      <QuestionBox
        v-for="(opt,ind) in list.slice(0, 3)"
        :key="ind"  
        :question="opt"
        />      
    </div>
  </div>

</template>



<script setup lang="ts">

interface Props {
  title: string,
  showmore: string,
  limit?: number,
  list: any[],
  cnt: number,
  link: string
}

const props = defineProps<Props>();
  

</script>

<style scoped>

.questionlist{ 
  width: 100%; 
  gap: 15px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  column-count: 3;
}
.questionlist > div{ 
  max-width: 32%;
}

@container pb (max-width: 800px) {

  .questionlist > div{ 
    max-width: 48%;
  }
  .questionlist  {
    column-count: 2;
  }
}

@container pb (max-width: 500px) {


  .questionlist > div{ 
    max-width: 100%;
  }
  .questionlist  {
    column-count: 1;
  }
}



</style>
